import * as React from "react";
import { useEffect, useState } from "react";
import { ProtectedPageWrapper } from "../../designSystem/layouts/pageWrappers/ProtectedPageWrapper";
import { getActiveUser, refresh } from "../../api/authClientApi";
import UserPanel from "../_components/userEditor/UserPanel";
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { H1 } from "../../designSystem/typography/Heading";
import { PublicAmorgUser } from '../../amorg-common';

export default function ProfilePage(): JSX.Element {

	const [activeUser, setActiveUser] = useState<PublicAmorgUser>(undefined);

	useEffect(() => {
        getData();
    }, []);

	const getData = async () => {
		await refresh();
		const activeUser = await getActiveUser();
		setActiveUser(activeUser);
	};

    const handleSelectedUserUpdated = async () => {
		await getData();
	} 

	return (
		<ProtectedPageWrapper requiredPermissions={['EditUser']}>
			<SingleColumnLayout
				headerContainer={
					<H1>Profilindstillinger</H1>
				}
				contentContainer={
					<>
						{activeUser &&
							<UserPanel 
								activeUser={activeUser}
								targetUserId={activeUser.id}
								onSelectedUserUpdated={handleSelectedUserUpdated} />
						}
					</>
				}
			/>
		</ProtectedPageWrapper>
	);
}